var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../../styled';
import { Icons, TextButton } from '../../../index';
const Container = styled.div `
  box-sizing: border-box;
  position: ${({ isExpand }) => (isExpand ? 'initial' : 'absolute')};
  bottom: 0;
  left: 50%;
  width: ${({ width }) => width};
  padding: ${({ layerPadding }) => layerPadding};
  background: ${({ layerBackground }) => layerBackground};
  ${({ isExpand }) => isExpand
    ? css `
          margin: 0 auto;
        `
    : css `
          transform: translateX(-50%);
        `}

  > button {
    margin: 0 auto;
    display: block;
  }
  svg {
    transform: ${({ isExpand }) => `rotate(${isExpand ? 0 : 180}deg)`};
  }
`;
const BottomButton = (_a) => {
    var { onClick, width = '100%', buttonStyle = 'Secondary', isExpand, hideButtonText, showButtonText, layerBackground = 'linear-gradient(180deg, rgba(250, 250, 250, 0.0001) -36.18%,#fafafa 50%)' } = _a, props = __rest(_a, ["onClick", "width", "buttonStyle", "isExpand", "hideButtonText", "showButtonText", "layerBackground"]);
    const OnClickButton = TextButton[buttonStyle];
    return (React.createElement(Container, Object.assign({}, props, { layerBackground: layerBackground, isExpand: isExpand, width: width }),
        React.createElement(OnClickButton, { onClick: onClick },
            isExpand ? hideButtonText : showButtonText,
            React.createElement(Icons.Outline.Chevron, { size: "SMALL" }))));
};
export default BottomButton;
//# sourceMappingURL=BottomButton.js.map